export default class RepStatusButton {
	Name: string;
	Action?: string;
	CanDo?: boolean;
	CantDoReason?: string;
	Type: StatusButton;
}

export enum StatusButton {
	Activate,
	Deactivate,
	CompleteOnboarding,
	StartOnboarding,
	StartSuspension,
	EndSuspension,
	ExtendContingentStart,
	ContingentlyActivate,
	SetOnHold,
	SetOffHold,
	Terminate,
	Blocklist,
	VersionCopy,
	DeactivateAll,
	ForceActivate,
}
